"use client";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import SectionHeading from "../shared/SectionHeading";
import content from "../../assets/course-details/other/Content.svg";
import blueBorder from "../../assets/course-details/blueBorder.png";
import yellowBorder from "../../assets/course-details/yellowBorder.png";

const HowToApply = ({ data }) => {
  const IMAGE_BASE = process.env.REACT_APP_IMAGE_URL;

  if (!data.section[12].isActive) {
    return <div></div>;
  }

  function oddCheck(value) {
    const num = parseInt(value);
    return num === 0 || num === 2 || num % 2 === 0;
  }

  const steps = data.section[12].body.list1;

  return (
<div className="my-16 py-12 bg-gradient-to-br from-[#f7faff] to-[#eaf0ff] overflow-x-auto">
  <SectionHeading>
    <span className="text-primary-color">How To</span>{" "}
    <span className="text-secondary-color">Apply</span>
  </SectionHeading>

  <div className="mt-14 mx-auto max-w-[1400px] px-2 sm:px-4 lg:px-8">
    <div className="flex flex-wrap justify-between gap-8">
      {steps.map((item, index) => (
        <div
          key={index}
          className="flex items-start space-x-4 min-w-[260px] max-w-[300px] flex-1"
        >
          {/* Step Number Circle */}
          <div className="flex items-center justify-center w-12 h-12 bg-primary-color text-white text-xl font-bold rounded-full shrink-0">
            {index + 1}
          </div>

          {/* Step Content */}
          <div className="flex flex-col">
            {/* Icon */}
            <div className="w-10 h-10 mb-2">
              <img
                src={`${IMAGE_BASE}/${item.image}`}
                alt="Icon"
                className="w-full h-full object-contain"
              />
            </div>
            <h3 className="text-lg font-semibold text-[#0a1a3a] mb-1">
              {item.title || ""}
            </h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              {item.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>


  );
};

export default HowToApply;
